import { render, staticRenderFns } from "./treatmentPlanProblemRep.vue?vue&type=template&id=2daeb9b8&"
import script from "./treatmentPlanProblemRep.vue?vue&type=script&lang=js&"
export * from "./treatmentPlanProblemRep.vue?vue&type=script&lang=js&"
import style0 from "./treatmentPlanProblemRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports